import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as Sentry from '@sentry/browser';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistReducer, persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import storage from 'redux-persist/lib/storage';
import thunkMiddleware from 'redux-thunk';
import { ConnectedApp } from './App';
import { attributionMiddleware } from './middleware/attributionMiddleware';
import { rootReducer } from './reducers';
import { unregister } from './registerServiceWorker';
import { AppState, hydrateInitialState } from './store';

Sentry.init({
  dsn: 'https://7480ef1b829241eebfd906bafec3c039@sentry.io/1784046',
  enabled: process.env.NODE_ENV === 'production',
  release: process.env.SENTRY_RELEASE,
  // See https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/16
  ignoreErrors: ['Non-Error exception captured', 'Non-Error promise rejection captured'],
});

unregister();
Modal.setAppElement('#root');

// turn off dev tools in production
let enhancers;
if (process.env.NODE_ENV === 'production') {
  enhancers = applyMiddleware(thunkMiddleware, attributionMiddleware);
} else {
  enhancers = composeWithDevTools(applyMiddleware(thunkMiddleware, attributionMiddleware));
}

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['utmData'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore<AppState>(persistedReducer, hydrateInitialState(), enhancers);

const persistor = persistStore(store);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <ConnectedApp />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root') as HTMLElement,
);
